/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { useIsAuthenticated } from "@azure/msal-react";
import { SignOutButton } from "./SignOutButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";
import myIcon from "../assets/redchat.svg";
import Button from "@mui/material/Button";
import aruplogo from '../assets/Arup_Logo_Red_RGB.png';

/**
 * Renders the navbar component with a sign in or sign out button depending on whether or not a user is authenticated
 * @param props
 */

const ArupLogo=()=>{
	return (<img src={aruplogo}
	alt="Arup Logo"
	style={{width:"100px",height:"auto",marginLeft:"12px",}}
	/>
	);
}
export const PageLayout = (props) => {
    const isAuthenticated = useIsAuthenticated();
    const [anchorEl, setAnchorEl] = useState();
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const navigate = useNavigate();
    const navigateToAbout = () => {
        navigate("/about");
        handleClose();
    };
    const navigateToHome = () => {
        navigate("/");
        handleClose();
    };

    return (
        <>
            <AppBar
                position="fixed"
                style={{ background: "white", color: "E61E28" }}
            >
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        onClick={navigateToHome}
                    >
                        {/* <MenuIcon /> */}
                        <img
                            src={myIcon}
                            alt="My Custom Icon"
                            width="24"
                            height="24"
                        />
                    </IconButton>

                    <Typography variant="h6" color="#E61E28">
                        Generate Your Own Design Check Calculation
                    </Typography>

                    
                    <Box sx={{ flexGrow: 1 }} />

                    <Button
                        style={{
                            backgroundColor: "transparent",
                            color: "#E61E28",
                            boxShadow: "none",
                            marginRight: "8px",
                        }}
                        onClick={navigateToAbout}
                    >
                        Documentation
                    </Button>
                    {/* {isAuthenticated ? <SignOutButton /> : <SignInButton />} */}
					<SignOutButton/>

					<ArupLogo />
                </Toolbar>
            </AppBar>
            {props.children}
        </>
    );
};
